export const templateLength = 9000;
